import * as yup from "yup";

export const createValidationSchema = yup.object().shape({
  code: yup.string().min(2, "Mã mặt hàng phải có ít nhất 2 ký tự"),
  name: yup
    .string()
    .min(2, "Tên mặt hàng phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập tên mặt hàng"),
  spec: yup.string().nullable().optional(),
  unitId: yup.string().required("Vui lòng chọn đơn vị tính"),
  priceNet: yup
    .number()
    .min(0, "Giá Net phải lớn hơn hoặc bằng 0")
    .required("Vui lòng nhập giá Net"),
  categoryId: yup.string().required("Vui lòng chọn nhóm hàng hóa"),
  notes: yup.string().nullable().optional(),
});
